import { render, staticRenderFns } from "./ServiceTypePrompt.vue?vue&type=template&id=04fa2019"
import script from "./ServiceTypePrompt.vue?vue&type=script&lang=js"
export * from "./ServiceTypePrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports